package co.maytes.standupbot.dashboard.features.onboarding

enum class NodeState { Done, Current, Upcoming }

object WizardProgress {
    fun nodeState(index: Int, current: Int): NodeState = when {
        index < current -> NodeState.Done
        index == current -> NodeState.Current
        else -> NodeState.Upcoming
    }

    fun fraction(index: Int, total: Int): Double =
        if (total <= 1) 0.0 else (index.coerceIn(0, total - 1)).toDouble() / (total - 1)

    fun fillFrom(current: Int, total: Int): Double = fraction(current - 1, total)

    fun fillTo(current: Int, total: Int): Double = fraction(current, total)

    fun justCompleted(index: Int, current: Int): Boolean = index == current - 1
}
